export const SUPPORT_ARTICLE_SLUGS = {
  technicalRequirements: 'technical-requirements',
  cameraSafari: 'camera-safari',
  cameraChrome: 'camera-chrome',
  cameraEdge: 'camera-edge',
  viewYourEarnedBadges: 'view-your-earned-badges',
  taoGettingStarted: 'tao-getting-started',
  signUpAndNavigationGuide: 'sign-up-and-navigation-guide',
  whatServices: 'what-services',
  whatStates: 'what-states',
  prescriptions: 'prescriptions',
  doYouOfferInPersonAppointments: 'do-you-offer-in-person-appointments',
  disabilityForms: 'disability-forms',
  emotionalSupportAnimalLetter: 'emotional-support-animal-letter',
  workplaceAccommodationsLetter: 'workplace-accommodations-letter',
  courtOrderedTherapy: 'court-ordered-therapy',
  verifyProviders: 'verify-providers',
  substituteForInPersonTherapy: 'substitute-for-in-person-therapy',
  howDoYouMatchMeWithATherapist: 'how-do-you-match-me-with-a-therapist',
  howDoIStartTherapy: 'how-do-i-start-therapy',
  howCanIContactMyProvider: 'how-can-i-contact-my-provider',
  changeProvider: 'change-provider',
  startPsychiatry: 'start-psychiatry',
  scheduleSessions: 'schedule-sessions',
  howDoIMeetWithMyProvider: 'how-do-i-meet-with-my-provider',
  howSoonCanIStartAttendingTherapy: 'how-soon-can-i-start-attending-therapy',
  travelingOrVacation: 'traveling-or-vacation',
  doYouDoTherapySessionsForCouplesAndFamilies: 'do-you-do-therapy-sessions-for-couples-and-families',
  doYouAcceptChildrenAsClients: 'do-you-accept-children-as-clients',
  familyMembersShareAccount: 'family-members-share-account',
  partnerProfileForCouples: 'partner-profile-for-couples',
  couplesSeparateLocations: 'couples-separate-locations',
  canIChangeMyPronounsWheneverIWant: 'can-i-change-my-pronouns-whenever-i-want',
  howDoIUpdateMyAddress: 'how-do-i-update-my-address',
  howDoIResetMyPassword: 'how-do-i-reset-my-password',
  howDoIChangeMyPhoneNumber: 'how-do-i-change-my-phone-number',
  howDoIChangeMyEmailAddress: 'how-do-i-change-my-email-address',
  canISignUpForTextReminders: 'can-i-sign-up-for-text-reminders',
  howDoIStopReceivingTextMessages: 'how-do-i-stop-receiving-text-messages',
  howDoIChangeMyEmergencyContact: 'how-do-i-change-my-emergency-contact',
  cardOnFileCharges: 'card-on-file-charges',
  separateFee: 'separate-fee',
  sessionCosts: 'session-costs',
  paymentTypes: 'payment-types',
  paymentSessionHistory: 'payment-session-history',
  subscription: 'subscription',
  acceptMyInsurance: 'accept-my-insurance',
  howDoIUpdateMyInsuranceInformation: 'how-do-i-update-my-insurance-information',
  secondaryInsurance: 'secondary-insurance',
  howDoIUpdateMyPaymentMethod: 'how-do-i-update-my-payment-method',
  canIPayUsingMyHsaOrFsaCard: 'can-i-pay-using-my-hsa-or-fsa-card',
  troubleJoiningSession: 'trouble-joining-session',
  supportedDevices: 'supported-devices',
  betterhelpRebrandFaq: 'betterhelp-rebrand-faq',
} as const;

export type SupportArticleSlug = typeof SUPPORT_ARTICLE_SLUGS[keyof typeof SUPPORT_ARTICLE_SLUGS];

export type SupportArticleCategory =
  'getting-started' | 'matching' | 'sessions' | 'account' | 'payments' | 'technical' | 'services' | 'family-couples' | 'tao' | 'general';

export const SUPPORT_ARTICLE_CATEGORY_LABELS: Record<SupportArticleCategory, string> = {
  'getting-started': 'Getting Started',
  'matching': 'Matching & Care',
  'sessions': 'Sessions',
  'account': 'Account Settings',
  'payments': 'Payments & Insurance',
  'technical': 'Technical Support',
  'services': 'Services & Policies',
  'family-couples': 'Family & Couples',
  'tao': 'TAO by BetterHelp',
  'general': 'General',
};

export const SUPPORT_ARTICLE_CATEGORY_DESCRIPTIONS: Record<SupportArticleCategory, string> = {
  'getting-started': 'Sign up, navigation, and what BetterHelp offers.',
  'matching': 'Start care, matching, and changing providers.',
  'sessions': 'Schedule and attend sessions with your provider.',
  'account': 'Password, contact info, and notification preferences.',
  'payments': 'Charges, costs, insurance, and payment methods.',
  'technical': 'Devices, permissions, and session troubleshooting.',
  'services': 'What BetterHelp can and cannot provide.',
  'family-couples': 'Couples and family therapy questions.',
  'tao': 'Guides for using TAO.',
  'general': 'Company updates and other FAQs.',
};

export const SUPPORT_ARTICLE_CATEGORY_ORDER: SupportArticleCategory[] = [
  'getting-started',
  'matching',
  'sessions',
  'account',
  'payments',
  'technical',
  'services',
  'family-couples',
  'general',
];
